import { render, staticRenderFns } from "./StatusPage.vue?vue&type=template&id=f6b18162"
import script from "./StatusPage.vue?vue&type=script&lang=ts"
export * from "./StatusPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports